module.exports = __webpack_public_path__ + "img/Apple_Pay_Mark_RGB_041619.fe4f01ad.svg";